import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
const Consignee = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    return (
        <div className='card p-3'> <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                    {/* <span className="avatar avatar-md rounded text-dark border me-2">
                    <i className="ti ti-user-plus fs-20" />
                </span> */}
                    Preferred Delivery Handler</Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        <div className="col-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        For Air
                                    </label>

                                </div>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        For LCL
                                    </label>

                                </div>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        For FCL
                                    </label>

                                </div>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                                {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                            </div>
                        </div>
                    </div>
                </Accordion.Body>
            </Accordion.Item>

        </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Delivery coordinator</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Sea
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>

                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Customer Services</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Sea
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>

                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Account Manager</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Sea
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Land
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                       Currency Uplift (CFX)</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">

                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <div className="row">
                                        <div className="col-8">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name="name"
                                                placeholder='Enter For Air'
                                            // onChange={formik.handleChange}
                                            // onBlur={formik.handleBlur}
                                            // value={formik.values.name}
                                            />
                                        </div>
                                        <div className="col-4">

                                            <Select

                                                className='custom-selector'
                                                options={ApplicableOption}
                                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Land
                                        </label>

                                    </div>
                                    <div className="row">
                                        <div className="col-8">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name="name"
                                                placeholder='Enter For Air'
                                            // onChange={formik.handleChange}
                                            // onBlur={formik.handleBlur}
                                            // value={formik.values.name}
                                            />
                                        </div>
                                        <div className="col-4">

                                            <Select
                                                className='custom-selector'
                                                options={ApplicableOption}
                                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <hr />
            <div className="row justify-content-end mt-3 gap-2">
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & New
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Close
                </button>

            </div>
        </div>
    )
}

export default Consignee